// 再生中リストを管理するID
let playingBufferSourceId = 0

// スコア上の音を管理するID
let soundOnScoreId = 0

/**
 * AudioContextを作成する
 */
export function createAudioContext (): AudioContext | null {
  if (window.AudioContext || window.webkitAudioContext) {
    // webkitAudioContext は Safari、古いChrome対策
    return new (window.AudioContext || window.webkitAudioContext)()
  } else {
    // IE11はAudioContextが存在しない
    return null
  }

  // // webkitAudioContext は Safari、古いChrome対策
  // const ctx = new (window.AudioContext || window.webkitAudioContext)()
  //
  // // iOSではユーザー操作で実行しておかないと音が出せないので、その対策
  // const initAudioContext = () => {
  //   document.removeEventListener('touchstart', initAudioContext)
  //
  //   const emptySource = ctx.createBufferSource()
  //   emptySource.start()
  //   emptySource.stop()
  // }
  //
  // document.addEventListener('touchstart', initAudioContext)
  //
  // return ctx
}

/**
 * 音を再生
 * @param ctx オーディオコンテキスト
 * @param audioBuffer 再生する音
 * @param when 再生開始位置
 */
export function playAudio (ctx: AudioContext | null, audioBuffer: AudioBuffer, when = 0): AudioBufferSourceNode | null {
  if (ctx) {
    const bufferSource = ctx.createBufferSource()

    // 変換されたバッファーを音源として設定
    bufferSource.buffer = audioBuffer

    // 出力につなげる
    bufferSource.connect(ctx.destination)
    bufferSource.start(ctx.currentTime + when)

    return bufferSource
  } else {
    // AudioContextが存在しない場合はnullを返す
    return null
  }
}

/**
 * 再生中リストのIDを生成する
 * ユニークにするためにこの関数で生成する
 */
export function createPlayingAudioBufferId (): number {
  return playingBufferSourceId++
}

/**
 * スコア上の音のIDを生成する
 * ユニークにするためにこの関数で生成する
 */
export function createSoundOnScoreId (): number {
  return soundOnScoreId++
}

/**
 * 無音を再生
 * iOSなどのオーディオ再生制限をクリアするため
 * @see https://qiita.com/pentamania/items/2c568a9ec52148bbfd08#%E3%82%B5%E3%83%B3%E3%83%97%E3%83%AB%E3%82%B3%E3%83%BC%E3%83%89%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6
 * @param audioContext
 */
export function playSilent (audioContext: AudioContext | null) {
  if (audioContext) {
    const buf = audioContext.createBuffer(1, 1, 22050)
    const src = audioContext.createBufferSource()

    src.buffer = buf
    src.connect(audioContext.destination)
    src.start(0)
  }
}
